<template>
    <div class="card animated fadeInUp faster">
        <div class="card-header text-center">
            <h5 class="mb-0 font-weight-normal">Your {{ selectedMethod.name }} Voucher</h5>
        </div>
        <div class="card-body p-0 pb-3">
            <iframe class="w-100 border-0 voucher-iframe" :src="setupResponse.data.url"></iframe>
        </div>
        <div class="card-footer">
            <div class="row align-items-center">
                <div class="col-md-6 col-lg-6 mb-4 mb-md-0 mr-md-0">
                    <a @click="back" href="javascript:void(0);" class="btn btn-text d-block d-md-inline-block px-0"><i class="fas fa-angle-left mr-3"></i> Cancel transfer</a>
                </div>
                <div class="col-md-6 col-lg-6 text-md-right">
                    <a :href="setupResponse.data.next" class="btn btn-primary">I have sent my payment <i class="fas fa-angle-right ml-3"></i></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState } from "vuex";

    export default {
        name: "SetupResponseEbanxVoucher",
        computed: {
            ...mapState({
                selectedMethod: state => state.payment.selectedMethod,
                setupResponse: state => state.payment.setupResponse
            })
        },
        methods: {
            back () {
                this.$store.commit('setSetupResponse', null);
            }
        }
    }
</script>

<style scoped>
    .voucher-iframe {
        min-height:1250px;
    }
</style>
